import { BaseEntity } from 'src/app/base/base-entity';

export class Export extends BaseEntity {
  fileType: string;
  single_processing_Date: string;
  baseUrl: string;
  defaultExportAttr: string;
}
